import { useEffect, useState } from 'react';
import { LButton } from './LButton';

const ITEMS = [
  { href: '#formats', label: 'Форматы' },
  { href: '#method',  label: 'Методика' },
  { href: '#cases',   label: 'Кейсы' },
  { href: '#about',   label: 'Обо мне' },
  { href: '#faq',     label: 'FAQ' },
  { href: '#contact', label: 'Обратная связь' },
];

export function LandingHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 transition-colors ${
        scrolled ? 'bg-l-paper/85 backdrop-blur border-b border-l-rule' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-[1120px] px-6 md:px-10 h-16 flex items-center justify-between gap-6">
        <a href="#top" className="flex flex-col leading-tight">
          <span className="font-display italic text-l-ink-deep text-[17px] md:text-[18px] leading-none">
            Мария Брызгалова
          </span>
          <span className="hidden sm:block font-sans text-l-ink-muted text-[10px] uppercase tracking-[0.14em] mt-[3px]">
            Репетитор по математике
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-6 font-sans text-[13px] text-l-ink-muted">
          {ITEMS.map((it) => (
            <a key={it.href} href={it.href} className="hover:text-l-ink-deep transition-colors whitespace-nowrap">
              {it.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <LButton href="https://board.matemasha.ru" variant="secondary" className="h-10 px-5 text-[14px]">
            Вход для учеников
          </LButton>
          <LButton href="#contact" variant="primary" className="h-10 px-5 text-[14px]">
            Записаться
          </LButton>
        </div>

        <button
          aria-label="Меню"
          aria-expanded={open}
          className="md:hidden flex flex-col gap-1 p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="block w-5 h-px bg-l-ink" />
          <span className="block w-5 h-px bg-l-ink" />
          <span className="block w-5 h-px bg-l-ink" />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-l-rule bg-l-paper">
          <nav className="flex flex-col px-6 py-4 font-sans text-[15px]">
            {ITEMS.map((it) => (
              <a
                key={it.href}
                href={it.href}
                onClick={() => setOpen(false)}
                className="py-3 border-b border-l-rule text-l-ink"
              >
                {it.label}
              </a>
            ))}
            <a
              href="https://board.matemasha.ru"
              onClick={() => setOpen(false)}
              className="mt-4 py-3 rounded-[10px] border border-l-ink text-l-ink text-center font-semibold"
            >
              Вход для учеников
            </a>
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 py-3 rounded-[10px] bg-l-terracotta text-white text-center font-semibold"
            >
              Записаться
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
